import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { IAccount } from 'src/types';
import { setAccount } from './account.slice';

export default function useAccount() {
  const dispatch = useDispatch();
  const account = useAppSelector((state) => state.account);

  const changeAccount = (account: IAccount | null) => {
    dispatch(setAccount(account));
  };

  const clear = () => {
    changeAccount(null);

    localStorage.removeItem('accesstoken');
    localStorage.removeItem('refreshtoken');
    localStorage.removeItem('expire');
  };

  return {
    account,
    changeAccount,
    clear,
  };
}
